export default "__VITE_ASSET__DOqc2Qqp__"